import { addHours, format } from 'date-fns'
import { getDefaultStore } from 'jotai'

import { DatesData } from '@dfds-pax/shared-components/client'

import { selectedOfferAtom } from '@/states/selectionAtom'

import { RouteFilter } from './RouteFilters'

export const datesMapper = (
  selectedRouteDates: DatesData,
  compoundRouteDates: DatesData,
  returnLeg: boolean,
  compoundRoute: string,
  selectedRouteFilters: RouteFilter,
  selectedOutbound?: string
): DatesData => {
  const store = getDefaultStore()
  const selectedOffer = store.get(selectedOfferAtom)

  //If we have a RestrictedLengthOfStay offer, we only mark offerdates on return that are within the RLS range.
  if (returnLeg && selectedOffer.offerRLSHours && selectedRouteDates?.dates?.fromDate) {
    const returnRSLOfferDates = format(
      addHours(new Date(selectedOutbound ?? selectedRouteDates.dates.fromDate), selectedOffer.offerRLSHours),
      'y-MM-dd'
    )
    selectedRouteDates.offerDates = selectedRouteDates.offerDates.filter((date) => date <= returnRSLOfferDates)
    return selectedRouteDates
  }

  if (selectedRouteDates && compoundRouteDates && selectedRouteFilters) {
    if (selectedRouteFilters.frcqf && selectedRouteFilters.frdkk) {
      const fromDate =
        selectedRouteDates.dates.fromDate <= compoundRouteDates.dates.fromDate
          ? selectedRouteDates.dates.fromDate
          : compoundRouteDates.dates.fromDate
      const toDate =
        selectedRouteDates.dates.toDate >= compoundRouteDates.dates.toDate
          ? selectedRouteDates.dates.toDate
          : compoundRouteDates.dates.toDate
      const offerDates: string[] = selectedRouteDates.offerDates.concat(compoundRouteDates.offerDates)
      const disabledDates: string[] = selectedRouteDates.disabledDates.concat(compoundRouteDates.disabledDates)

      return {
        dates: {
          fromDate: fromDate,
          toDate: toDate,
        },
        defaultDate: selectedRouteDates.defaultDate,
        disabledDates: disabledDates,
        offerDates: offerDates,
      }
    }

    if (selectedRouteFilters?.frcqf && !selectedRouteFilters?.frdkk) {
      return compoundRoute === 'DVDK' || compoundRoute === 'DKDV' ? selectedRouteDates : compoundRouteDates
    }

    if (!selectedRouteFilters?.frcqf && selectedRouteFilters?.frdkk) {
      return compoundRoute === 'DVDK' || compoundRoute === 'DKDV' ? compoundRouteDates : selectedRouteDates
    }
  }

  return selectedRouteDates
}
